import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import color from "../../../Constants/colors";
import { VoicesTopicOrigin, VoicesTopicStatus } from "../../../Enums/voices";
import { VoicesTopic } from "../../../Models/voicesTopics";
import { VoicesStatusTag } from "../Common/VoicesFilterParts";

interface Props {
  topic: VoicesTopic;
  showStatus?: boolean;
  showOrigin?: boolean;
}

export const MAX_SCORE_PER_CRITERION = 3;

export const TOPIC_STATUS_KEYS: Record<VoicesTopicStatus, string> = {
  [VoicesTopicStatus.NEW]: "statusNew",
  [VoicesTopicStatus.USED]: "statusUsed",
  [VoicesTopicStatus.DISMISSED]: "statusDismissed",
};

export const ORIGIN_KEYS: Record<VoicesTopicOrigin, string> = {
  [VoicesTopicOrigin.RSS]: "originRss",
  [VoicesTopicOrigin.WEB]: "originWeb",
  [VoicesTopicOrigin.MANUAL]: "originManual",
  [VoicesTopicOrigin.AGENT]: "originAgent",
};

const ORIGIN_TONES: Record<VoicesTopicOrigin, string> = {
  [VoicesTopicOrigin.RSS]: color.orange600,
  [VoicesTopicOrigin.WEB]: color.blue700,
  [VoicesTopicOrigin.MANUAL]: color.gray600,
  [VoicesTopicOrigin.AGENT]: color.blue700,
};

const STATUS_TONES: Record<VoicesTopicStatus, string> = {
  [VoicesTopicStatus.NEW]: color.orange600,
  [VoicesTopicStatus.USED]: color.green700,
  [VoicesTopicStatus.DISMISSED]: color.gray600,
};

const VoicesTopicChips: React.FC<Props> = ({ topic, showStatus = true, showOrigin = false }) => {
  const { t } = useTranslation("voicesTopics");

  return (
    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
      {topic.scores.length > 0 && (
        <VoicesStatusTag
          label={t("score", {
            score: topic.total_score,
            max: topic.scores.length * MAX_SCORE_PER_CRITERION,
          })}
          tone={color.gray700}
        />
      )}
      {topic.confidential && <VoicesStatusTag label={t("confidential")} tone={color.red700} />}
      {showOrigin && (
        <VoicesStatusTag label={t(ORIGIN_KEYS[topic.origin])} tone={ORIGIN_TONES[topic.origin]} />
      )}
      {showStatus && (
        <VoicesStatusTag
          label={t(TOPIC_STATUS_KEYS[topic.status])}
          tone={STATUS_TONES[topic.status]}
        />
      )}
    </Box>
  );
};

export default VoicesTopicChips;
